module.exports = __webpack_public_path__ + "static/media/stjosephbukittimah.555fe64a.webp";